import { render, staticRenderFns } from "./CommunityMember.vue?vue&type=template&id=0de09cd9&scoped=true"
import script from "./CommunityMember.vue?vue&type=script&lang=js"
export * from "./CommunityMember.vue?vue&type=script&lang=js"
import style0 from "./CommunityMember.vue?vue&type=style&index=0&id=0de09cd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de09cd9",
  null
  
)

export default component.exports